import { pushErrorModalAction } from 'actions/app-actions';
import { ERROR_MODAL_TYPE } from 'components/v2/error-modal/error-modal';
import I18n from 'i18n-js';
import { PARSE_EXCEL_ERROR_CODE } from 'constants/new-bulk-upload-const';
import scribeNewBulkUploadDuck from 'ducks/scribe-new-bulk-upload-duck';

const getErrorMessage = error => {
  const { errorCode, fieldName, rowIndex, bookingLimit } = error;
  switch (errorCode) {
    case PARSE_EXCEL_ERROR_CODE.TEMPLATE_ERROR:
      return [
        I18n.t(
          'phrase.geWebBulkUpload.express_web_bulk_upload_heading_template_not_recognised_error',
        ),
        I18n.t(
          'phrase.geWebBulkUpload.express_web_bulk_upload_body_use_latest_template_error',
        ),
        I18n.t('v2.error.uploadOrder.parseError.emptyDataError.okButtonText'),
      ];
    case PARSE_EXCEL_ERROR_CODE.EMPTY_DATA_ERROR:
      return [
        I18n.t('v2.error.uploadOrder.parseError.emptyDataError.title'),
        I18n.t('v2.error.uploadOrder.parseError.emptyDataError.description'),
        I18n.t('v2.error.uploadOrder.parseError.emptyDataError.okButtonText'),
      ];
    case PARSE_EXCEL_ERROR_CODE.INVALID_DATA_ERROR:
      return [
        I18n.t(
          'v2.error.uploadOrder.parseError.invalidDataErrorWithFieldName.title',
        ),
        I18n.t(
          'v2.error.uploadOrder.parseError.invalidDataErrorWithFieldName.description',
          {
            fieldName: I18n.t(`bulkUploadRevamp.fields.${fieldName}`),
            rowIndex: rowIndex + 1,
          },
        ),
      ];
    case PARSE_EXCEL_ERROR_CODE.REQUIRED_DATA_ERROR:
      return [
        I18n.t(
          'v2.error.uploadOrder.parseError.requiredDataErrorWithFieldName.title',
        ),
        I18n.t(
          'v2.error.uploadOrder.parseError.requiredDataErrorWithFieldName.description',
          {
            fieldName: I18n.t(`bulkUploadRevamp.fields.${fieldName}`),
            rowIndex: rowIndex + 1,
          },
        ),
      ];
    case PARSE_EXCEL_ERROR_CODE.FILE_SIZE_ERROR:
      return [
        I18n.t('v2.error.uploadOrder.parseError.fileSizeError.title'),
        I18n.t('v2.error.uploadOrder.parseError.fileSizeError.description'),
      ];
    case PARSE_EXCEL_ERROR_CODE.EXCEED_BOOKING_LIMIT_ERROR:
      return [
        I18n.t('v2.error.uploadOrder.parseError.exceedBookingLimitError.title'),
        I18n.t(
          'v2.error.uploadOrder.parseError.exceedBookingLimitError.description',
          {
            bookingLimit,
          },
        ),
      ];
    case PARSE_EXCEL_ERROR_CODE.MULTISTOP_VALIDATION_ERROR:
      return [
        I18n.t(
          'v2.error.uploadOrder.parseError.multistopValidationError.title',
        ),
        I18n.t(
          'v2.error.uploadOrder.parseError.multistopValidationError.description',
        ),
      ];
    case PARSE_EXCEL_ERROR_CODE.NOT_FOUND_WORK_SHEET:
      return [
        I18n.t('v2.error.uploadOrder.parseError.notFoundWorkSheet.title'),
        I18n.t('v2.error.uploadOrder.parseError.notFoundWorkSheet.description'),
      ];
    default:
      return [
        I18n.t('v2.error.uploadOrder.parseError.genericError.title'),
        I18n.t('v2.error.uploadOrder.parseError.genericError.description'),
      ];
  }
};

export const pushUploadExcelError = (dispatch, error) => {
  const { errorCode } = error;
  const shortErrorMsg = Object.keys(PARSE_EXCEL_ERROR_CODE).find(
    key => PARSE_EXCEL_ERROR_CODE[key] === errorCode,
  );
  const [message, description, okButtonText] = getErrorMessage(error);

  dispatch(
    pushErrorModalAction({
      message,
      description,
      okButtonText,
      type: ERROR_MODAL_TYPE.WARNING,
      onOk: () => {
        dispatch(
          scribeNewBulkUploadDuck.creators.scribeExpressNewBulkUploadErrorPageConfirmInvalidField(
            shortErrorMsg,
          ),
        );
      },
    }),
  );
  dispatch(
    scribeNewBulkUploadDuck.creators.scribeExpressNewBulkUploadErrorPageDefault(
      shortErrorMsg,
    ),
  );
};

export default {};
